export class Botadmin {
  constructor(public idusuario: string, public activado: boolean) {}
}

